<template>
	<div>
		<!-- 列表 -->
		<Popup
			v-model="list_display"
			title="查看"
			:width="950"
			confirmBtnText="新增"
			@confirmClick="handleAddClick"
		>
			<div v-loading="list_loading" style="padding: 15px;">
				<!-- 表格 -->
				<div class="base_table">
					<el-table
						:data="list_data"
						style="width: 100%"
					>
						<el-table-column
							prop="name"
							label="姓名"
						>
						</el-table-column>
						<el-table-column
							prop="time"
							label="提醒时间"
						>
						</el-table-column>
						<el-table-column
							prop="matter"
							label="备忘事宜"
							width="400"
						>
						</el-table-column>
						<el-table-column
							label="操作"
						>
							<template slot-scope="scope">
								<el-button
									@click="handleUpdateClick(scope.row)"
								>修改</el-button>
								<el-button
									type="danger"
									@click="handleDeleteClick(scope.row)"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 表格 end -->
			</div>
		</Popup>
		<!-- 列表 end -->
		
		<!-- 新增 -->
		<Popup
			v-model="add_display"
			title="新增"
			confirmBtnText="添加"
			@confirmClick="handleAddConfirmClick"
		>
			<div v-loading="add_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>备忘事宜</span>
					<el-input v-model="add_matter" :maxlength="100" placeholder="备忘事宜"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="add_matter_tip"><i class="b_icon"></i>请输入备忘事宜</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>提醒时间</span>
					<el-date-picker
						v-model="add_time"
						:editable="false"
						placeholder="提醒时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleAddTimeChange"
					>
					</el-date-picker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="add_time_tip"><i class="b_icon"></i>请选择提醒时间</template></div>
			</div>
		</Popup>
		<!-- 新增 end -->
		
		<!-- 修改 -->
		<Popup
			v-model="update_display"
			title="修改"
			@confirmClick="handleUpdateConfirmClick"
		>
			<div v-loading="update_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>备忘事宜</span>
					<el-input v-model="update_matter" :maxlength="100" placeholder="备忘事宜"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="update_matter_tip"><i class="b_icon"></i>请输入备忘事宜</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>提醒时间</span>
					<el-date-picker
						v-model="update_time"
						:editable="false"
						placeholder="提醒时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleUpdateTimeChange"
					>
					</el-date-picker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="update_time_tip"><i class="b_icon"></i>请选择提醒时间</template></div>
			</div>
		</Popup>
		<!-- 修改 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				required: true
			},
			firmId: {
				type: String,
				required: true
			},
			firmName: {
				type: String,
				required: true
			},
			code: {
				type: String,
				required: true
			},
			name: {
				type: String,
				required: true
			}
		},
		mounted () {
			this.update_id = '';
			this.delete_id = '';
			this.display && (this.list_display = true);
		},
		data() {
			return {
				list_display: false,
				list_loading: false,
				list_data: [],
				
				add_display: false,
				add_loading: false,
				add_matter: '',
				add_time: '',
				add_matter_tip: false,
				add_time_tip: false,
				
				update_display: false,
				update_loading: false,
				update_matter: '',
				update_time: '',
				update_matter_tip: false,
				update_time_tip: false
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/****************** @list **********************/
			// 获取患者备忘录
			getListData() {
				const that = this;
				that.list_loading = true;
				var requestData = {
					userId: that.uid
				};
				Api.findUserMemos(requestData).then((res) => {
					that.list_loading = false;
					if (res.data.success) {
						let _list = [];
						res.data.data.forEach(v => {
							_list.push({
								id: v.id,
								name: v.userName,
								time: v.time,
								matter: v.memorandumContent
							});
						});
						that.list_data = _list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			},
			
			
			/****************** @add **********************/
			// 点击新增 
			handleAddClick() {
				this.add_display = true;
			},
			// 提醒时间选择
			handleAddTimeChange() {
				if (this.add_time) {
					let remindTime = new Date(this.add_time).getTime();
					let now = new Date().getTime();
					if (remindTime <= now) {
						this.$message.error('提醒时间必须大于当前日期！！！');
						this.add_time = '';
					}
				}
			},
			// 点击新增弹框确定
			handleAddConfirmClick() {
				const that = this;
				if (!that.add_matter.trim()) {
					that.add_matter_tip = true;
					return false;
				} else {
					that.add_matter_tip = false;
				}
				if (!that.add_time) {
					that.add_time_tip = true;
					return false;
				} else {
					that.add_time_tip = false;
				}
				that.add_loading = true;
				let requestData = {
					"createTime": null,
					"creater": that.authInfo.uid,
					"dr": null,
					"enterpriseId": that.firmId,
					"enterpriseName": that.firmName,
					"id": null,
					"memorandumContent": that.add_matter,
					"remindTime": that.add_time,
					"time": null,
					"type": 'w',
					"updateTime": null,
					"userCode": that.code,
					"userId": that.uid,
					"userName": that.name
				};
				Api.addUserMemo(requestData).then((res) => {
					that.add_loading = false;
					if (res.data.success) {
						that.add_display = false;
						that.$message.success(res.data.message);
						that.getListData();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/****************** @update **********************/
			// 点击修改
			handleUpdateClick(data) {
				this.update_id = data.id;
				this.update_matter = data.matter;
				this.update_time = data.time;
				this.update_display = true;
			},
			// 提醒时间选择
			handleUpdateTimeChange() {
				if (this.update_time) {
					let remindTime = new Date(this.update_time).getTime();
					let now = new Date().getTime();
					if (remindTime <= now) {
						this.$message.error('提醒时间必须大于当前日期！！！');
						this.update_time = '';
					}
				}
			},
			// 点击修改弹框确定
			handleUpdateConfirmClick() {
				const that = this;
				if (!that.update_matter.trim()) {
					that.update_matter_tip = true;
					return false;
				} else {
					that.update_matter_tip = false;
				}
				if (!that.update_time) {
					that.update_time_tip = true;
					return false;
				} else {
					that.update_time_tip = false;
				}
				that.update_loading = true;
				let requestData = {
					"createTime": null,
					"creater": that.authInfo.uid,
					"dr": null,
					"enterpriseId": that.firmId,
					"enterpriseName": that.firmName,
					"id": that.update_id,
					"memorandumContent": that.update_matter,
					"remindTime": that.update_time,
					"time": null,
					"type": 'w',
					"updateTime": null,
					"userCode": that.code,
					"userId": that.uid,
					"userName": that.name
				};
				Api.updateUserMemo(requestData).then((res) => {
					that.update_loading = false;
					if (res.data.success) {
						that.update_display = false;
						that.$message.success(res.data.message);
						that.getListData();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/****************** @delete **********************/
			// 点击删除
			handleDeleteClick(data) {
				const that = this;
				this.$confirm(
					'此操作将删除对应备忘录，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.delete_id = data.id;
						that.deleteMemo();
					}
				).catch(
					() => {}
				);
			},
			// 删除备忘录
			deleteMemo() {
				const that = this;
				that.list_loading = true;
				let requestData = {
					id: that.delete_id
				};
				Api.deleteUserMemo(requestData).then((res) => {
					that.list_loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.getListData();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.list_display = newVal;
			},
			list_display(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getListData();
				} else {
					this.list_loading = false;
					this.list_data = [];
					this.delete_id = '';
				}
			},
			add_display(newVal) {
				if (!newVal) {
					this.add_loading = false;
					this.add_matter = '';
					this.add_time = '';
					this.add_matter_tip = false;
					this.add_time_tip = false;
				}
			},
			update_display(newVal) {
				if (!newVal) {
					this.update_loading = false;
					this.update_matter = '';
					this.update_time = '';
					this.update_matter_tip = false;
					this.update_time_tip = false;
				}
			}
		}
	}
</script>

<style>
</style>
